<template>
		<div id="pageRoot">

			<p id="text01">
				No es cierto que los perros no vuelan.
			</p>
			<p id="text02">
				Lo que pasa es que les gusta volar bajito. En mi barrio, por ejemplo, tenemos un perro que sabe volar; se llama Venancio.
			</p>
			<p id="text03">
				El que le enseñó a volar a Venancio fue don Fito, que tiene mucha paciencia.
			</p>
			<p id="text04">
				En realidad, primero le enseñó a saltar.
			</p>
			<p id="text05">
				Estuvo meses y meses<br>
				enseñándole a saltar.
			</p>
			<p id="text06">
				—¡Hop, Venancio! —decía<br>
				don Fito levantando<br>
				un dedo.<br>
			</p>


			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
			<div class="pageSVG">
				<img src="/pages/img/sordo/svgPage52.svg" class="pageElement" style=" width: 100%; height: auto;">
			</div>
			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		</div>
</template>
<style scoped>

#text01 {
/* No es cierto que los perros no vuelan. */
position: absolute;
width: 536px;
height: 33px;
left: 32px;
top: 105px;
margin: 0px;
z-index: 3;
font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 24px;
line-height: 33px;
/* identical to box height */
color: #000000;
}

#text02
{
	/* Lo que pasa es que les gusta volar bajito. En mi barrio, por ejemplo, tenemos un perro que sabe volar; se llama Venancio. */
position: absolute;
width: 922px;
height: 70px;
left: 32px;
top: 147px;
margin: 0px;
z-index: 3;
font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 24px;
line-height: 33px;
color: #000000;
}
#text03{
/* El que le enseñó a volar a Venancio fue don Fito, que tiene mucha paciencia. */

position: absolute;
width: 877px;
height: 35px;
left: 32px;
top: 223px;
margin: 0px;
z-index: 3;
font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 24px;
line-height: 33px;
color: #000000;
}

#text04{
/* En realidad, primero le enseñó a saltar. */

position: absolute;
width: 446px;
height: 38px;
left: 32px;
top: 265px;
margin: 0px;
z-index: 3;
font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 24px;
line-height: 33px;
color: #000000;
}

#text05{
/* Estuvo meses y meses enseñándole a saltar. */

position: absolute;
width: 379px;
height: 72px;
left: 32px;
top: 310px;
margin: 0px;
z-index: 3;
font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 24px;
line-height: 33px;
color: #000000;
}

#text06{
/* -¡Hop, Venancio! - decía don Fito levantando un dedo. */
position: absolute;
width: 282px;
height: 101px;
left: 26px;
top: 382px;
margin: 0px;
z-index: 3;
font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 24px;
line-height: 33px;
color: #000000;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p52/V15A.mp4", "p52/V15B.mp4", "p52/V15C.mp4"]
    }
  }
}
</script>